<template>
  <div class="course mt-5 mb-5" v-loading="loading">
    <div class="site-wrapper">
      <div class="main-wrapper">
        <div class="container-fluid select-course mb-5">
          <div class="row">
            <div class="col-6 d-flex align-items-center">
              <span style="font-weight: bold" class="pr-2">Chọn khóa học</span>
              <b-form-select
                v-model="course"
                label="Chọn khóa học"
                @change="loadCourse"
                :options="getCourseSelectList"
                style="max-width: 300px"
              />
            </div>
            <div class="col-6 referral-link d-flex align-items-center">
              <span style="font-weight: bold" class="pr-2">Mã giới thiệu </span>
              <el-input size="medium" ref="referallLink" :value="user.referral_code" readonly style="max-width: 200px">
                <el-button slot="append" size="medium" @click="copyToClipboard(user.referral_code, $event)">
                  <b-icon-clipboard/>
                </el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div v-if="course" class="container-fluid">
          <div class="row align-items-start">
            <div class="col-lg-9">
              <b-container fluid>
                <div class="row" style="min-height: 260px; max-height: 320px">
                  <div class="col-lg-7 pl-0 pr-0 d-flex align-items-end"
                    :style="`
                      background-image: url(${getMediaUrl(course.thumbnail_url)});
                      background-position: center;
                      background-size: cover;
                      background-repeat: no-repeat;
                      border-radius: 8px 0px 0px 8px;
                    `"
                  >
                    <div class="topic-card-list d-flex mb-2">
                      <div class="category-card ml-2 mr-1">
                        <b-icon-bar-chart />
                        <span class="ml-1">{{ get(course, 'category.name') }}</span>
                      </div>

                      <div class="category-card">
                        <b-icon-bar-chart />
                        <span class="ml-1">{{ get(course, 'topic.name') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 pl-0 pr-0 align-items-center d-flex" style="background: #194374; border-radius: 0px 8px 8px 0px;">
                    <b-container fluid class="p-0 h-100">
                      <div class="inner pl-3 pr-3 pb-4 pt-4 d-flex align-content-between flex-wrap h-100">
                        <div class="course-title w-100">
                          <div class="w-100"> {{ course.name }}</div>
                          <div class="pt-1 pb-1 w-100">
                            <img src="@/assets/images/icons/vector.svg" style="max-height: 9px"/>
                          </div>
                        </div>
                        <div class="course-info w-100">
                          <div class="row align-content-center">
                            <div class="col-6 d-flex justify-content-center flex-wrap">
                              <div class="rating-point pb-1 w-100 text-center">{{ getRatingPoint }}</div>
                              <div class="rating-stars w-100 text-center">
                                <b-form-rating
                                  :value="getRatingPoint"
                                  :readonly="true"
                                  :no-border="true"
                                  color="#FFD217"
                                  style="background-color: transparent;"
                                />
                              </div>
                            </div>
                            <div class="col-6 d-flex justify-content-center">
                              <div class="course-students group-3users-wrap d-flex align-items-center flex-wrap justify-content-center">
                                  <div v-if="!course.registered_user_avatars || course.registered_user_avatars.length === 0" class="students group-3users w-100 text-center">
                                      <img src="@/assets/images/temp/avatar48-1.png" alt="" class="rounded-circle avatar-image first">
                                      <img src="@/assets/images/temp/avatar48-2.png" alt="" class="rounded-circle avatar-image middle">
                                      <img src="@/assets/images/temp/avatar48-3.png" alt="" class="rounded-circle avatar-image last">
                                  </div>
                                  <div v-else class="students group-3users w-100 text-center">
                                    <img v-for="(url, index) in course.registered_user_avatars" :key="index" :src="url | getMediaUrl" alt="" :class="`rounded-circle avatar-image ${['first', 'middle', 'last'][index]}`">
                                  </div>
                                  <div class="text w-100 text-white text-center">{{ get(course, 'statistics.enrolled_count') || 0 }} người đã học</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-container>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-lg-4 p-0 pl-2 pr-5">
                    <!-- BEGIN Card Media -->
                    <div class="card card-video bg-transparent">
                        <div class="card-body p-0">
                            <div class="video-item">
                                <div class="video-header d-flex justify-content-between align-items-center mb-3">
                                    <h5 class="mb-0 mt-1"><strong>Thông tin khóa học</strong></h5>
                                </div>
                            </div>
                        </div>
                    </div><!-- END Card Media -->
                    <hr class="mt-0 mb-4">
                    <div class="course-statistic">
                      <div class="d-flex justify-content-center mb-5">
                        <div class="container">
                          <div class="info">
                            <span class="title">Ngày tạo: </span>
                            <span><strong>{{ course.created_at | getDate }}</strong></span>
                          </div>
                          <div class="info mt-3">
                            <span class="title">Tổng doanh thu: </span>
                            <span class="value"><strong>{{ 0 | vnd }}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div class="course-overview d-flex justify-content-between align-items-center">
                          <div class="container p-0" fluid>
                            <div class="row">
                              <div class="text-center col-4 p-0 border-right">
                                <ion-icon name="heart" class="icon" style="color: #FF5A8D; font-size: 24px"></ion-icon>
                                <div class="text-secondary statistic pt-2">{{ get(course, 'statistics.bookmark_count') || 0 }}</div>
                              </div>
                              <div class="text-center col-4 p-0 border-right">
                                  <ion-icon name="bookmark" class="icon" style="color: #FFBA55; font-size: 24px"></ion-icon>
                                  <div class="text-secondary statistic pt-2">{{ get(course, 'statistics.love_count') || 0 }}</div>
                              </div>
                              <div class="text-center col-4 d-flex align-content-between flex-wrap p-0">
                                <div class="d-flex align-content-center; justify-content-center w-100" style="color: #4477DB; font-size: 20px; height: 24px; font-weight: bold"><span>{{ students.length }}</span></div>
                                <div class="text-secondary statistic pt-2 w-100 tex-center">Học viên</div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8 p-0 pl-4 pr-2">
                    <b-tabs v-model="tabIndex" active-nav-item-class="active-nav-item">
                      <b-tab title="Bài tập về nhà">
                        <b-container fluid class="p-0 homeworks pt-3 pb-5">
                          <div class="number d-flex align-content-center align-items-center pb-2">
                            <ion-icon name="attach-outline" style="font-size: 22px"/>
                            <span><strong>{{ homeworks.length }} bài đã nộp</strong></span>
                          </div>
                          <div
                            v-for="(hk, index) in homeworks"
                            :key="hk._id"
                            class="ranking-item bg-transparent pt-1 pb-1 mb-1"
                            :class="(hk.points && hk.points > 0) ? 'item-scored' : 'item-not-scored'"
                            style="cursor: pointer"
                            @click="handleReview(index, hk)"
                          >
                              <div class="item-inner d-flex align-items-center bg-transparent pl-3 pr-3 pt-1 pb-1 justify-content-between">
                                  <div class="d-flex align-items-center bg-transparent mr-1" style="min-width: 180px">
                                      <div class="item-avatar rounded-circle mr-2">
                                          <img :src="get(hk, 'user.profile.pic') || '' | getMediaUrl" alt="" class="rounded-circle mx-100 mh-100" style="width: 36px; height: 36px">
                                      </div>
                                      <div class="student-name" style="color: #3E5BA6">
                                          <strong>{{ get(hk, 'user.profile.fullname') }}</strong>
                                      </div>
                                  </div>
                                  <div
                                    class="name d-flex align-items-center align-content-center homework-name mr-1"
                                    v-b-tooltip.hover :title="get(hk, 'homework.name')"
                                  >
                                    <ion-icon name="document-outline" />
                                    <span class="pl-1">{{ get(hk, 'homework.name') }}</span>
                                  </div>
                                  <div class="points mr-1 text-center d-flex justify-content-center align-content-center align-items-center" style="min-width: 100px">
                                    <span v-if="!hk.points || hk.points <= 0" style="color: #FF4874; font-weight: bold">
                                      Chưa chấm điểm
                                    </span>
                                    <div v-else class="rounded-circle d-flex align-items-center justify-content-center" style="width: 38px; height: 38px; background: #4477DB; color: #ffffff">
                                      {{ hk.points }}
                                    </div>
                                  </div>
                                  <div style="min-width: 70px">
                                    <span style="font-size: 11px; font-weight: bold; color: #848B96">{{ hk.created_at | getDate }}</span>
                                  </div>
                              </div>
                          </div>
                        </b-container>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </b-container>
            </div>
            <div class="col-lg-3 p-0">
              <b-container fluid>
                <div class="inner">
                  <div class="card card-ranking border-0 shadow-sm mb-4 student-list">
                    <div class="card-header pt-3 pb-3 d-flex justify-content-between align-items-center">
                        <h3 class="card-title"><strong>Danh sách học viên</strong></h3>
                        <div class="action">
                            <div class="num-student text-primary d-flex align-items-center">
                              <span class="pr-1">{{ students.length }}</span>
                              <b-icon-person />
                            </div>
                        </div>
                    </div>
                    <div class="table-ranking mt-2 mb-2 bg-transparent">
                        <div
                          v-for="student in students"
                          :key="student._id"
                          class="ranking-item bg-transparent"
                        >
                            <div class="item-inner d-flex align-items-center justify-content-between bg-transparent">
                                <div class="d-flex align-items-center flex-grow-1 bg-transparent">
                                    <div class="item-avatar rounded-circle mr-3">
                                        <img :src="get(student, 'user.profile.pic') || '' | getMediaUrl" alt="" class="rounded-circle mx-100 mh-100">
                                    </div>
                                    <div class="student-name">
                                        <strong>{{ get(student, 'user.profile.fullname') }}</strong>
                                    </div>
                                </div>
                                <div>
                                    <div class="rounded-circle badge">
                                      <b-icon-chat-square-text font-scale="1.3"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
              </b-container>
            </div>
          </div>

          <div class="row align-items-start pt-5">
            <div class="col-lg-12">
              <div class="chart-title text-center pb-4">Biểu đồ độ tuổi các học viên</div>
              <div class="chart-main">
                <BarChart
                  :height="424"
                  :chart-data.sync="ageChart"
                  :options="{
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                      padding: 0
                    }
                  }"
                />
                </div>
            </div>
          </div>

          <div class="row align-items-start pt-5">
            <div class="col-lg-6">
              <div class="chart-title text-center pb-4">Biểu đồ giới tính các học viên</div>
              <div class="chart-main">
                <PieChart
                  style="max-height: 424px"
                  :chart-data.sync="genderChart"
                />
                </div>
            </div>
            <div class="col-lg-6">
              <div class="chart-title text-center pb-4">Biểu đồ tiến độ học học viên</div>
              <div class="chart-main">
                <LineChart
                  :chart-data.sync="progressChart"
                />
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-if="homeworkTemp"
      v-model="reviewHomeWorkDialog"
      :title="`Bài học: ${get(homeworkTemp, 'homework.lesson.name')}`"
      ok-title="Lưu thay đổi"
      cancel-title="Hủy"
      size="lg"
      dialog-class="homework-dialog"
      @ok="reviewHomework"
    >
      <div class="homework-review p-2">
        <div class="title"><strong>Bài tập: {{ get(homeworkTemp, 'homework.name') }}</strong></div>
        <div class="content pl-2 pt-2" v-html="homeworkTemp.homework.content" />
      </div>

      <div class="student-homework p-2 mt-4">
        <div class="title" style="font-weight: bold">Câu trả lời của học viên:</div>
        <div class="content pl-2 pt-2" v-html="homeworkTemp.content" />
      </div>

      <div v-if="homeworkTemp.attachment" class="attachment p-2 mt-2">
        <div class="title" style="font-weight: bold">Đính kèm</div>
        <a class="attachment-file pl-2 pt-2" :href="homeworkTemp.attachment | getMediaUrl" target="__blank">
          <b-icon-paperclip />
          <span>{{ homeworkTemp.attachment.split('/').pop() }}</span>
        </a>
      </div>

      <div class="review-homework p-2 mt-4">
        <div class="title mb-2" style="font-weight: bold">Đánh giá</div>
        <b-form-input
          v-model="homeworkTemp.points"
          placeholder="Điểm số (Thang điểm 10)"
          type="number"
        />
        <b-form-textarea
          class="mt-2"
          id="textarea"
          v-model="homeworkTemp.teacher_comment"
          placeholder="Nhận xét"
          rows="3"
          max-rows="6"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import Clipboard from 'clipboard'
import { mapGetters } from 'vuex'
import { courseAgeStatistic, courseGenderStatistic, courseProgressStatistic } from '@/api/statistic'

import BarChart from '@/components/chart/Bar'
import PieChart from '@/components/chart/Pie'
import LineChart from '@/components/chart/Line'

export default {
  components: {
    BarChart,
    PieChart,
    LineChart
  },
  computed: {
    ...mapGetters({
      user: 'user',
      courses: 'courses',
      students: 'students',
      homeworks: 'homeworks'
    }),
    getCourseSelectList() {
      if (!this.courses) {
        return []
      }

      return this.courses.map(course => {
        return {
          text: course.name,
          value: course
        }
      })
    },
    getRatingPoint() {
      const sum = _.get(this.course, 'statistics.rating.points_sum') || 0
      const count = _.get(this.course, 'statistics.rating.count') || 1

      return (sum / count).toFixed(2)
    }
  },

  data() {
    return {
      tabIndex: 0,
      course: null,
      homeworkTemp: null,
      homeworkTempIndex: 0,
      reviewHomeWorkDialog: false,
      loading: false,
      ageChart: {},
      genderChart: {},
      progressChart: {}
    }
  },

  created() {
    this.initCourse()
  },

  methods: {
    initStatistics() {
      this.getCourseAgeStatistics()
      this.getCourseGenderStatistics()
      this.getCourseProgressStatistics()
    },
    getCourseAgeStatistics() {
      courseAgeStatistic(this.course._id)
        .then(response => {
          const data = response.data
          this.$set(this, 'ageChart', {
            labels: data.map(item => item._id !== null ? item._id : 'Không xác định'),
            datasets: [
              {
                label: 'Độ tuổi',
                backgroundColor: '#4F67E1',
                data: data.map(item => item.count),
                maxBarThickness: 100
              }
            ]
          })
        })
    },
    getGenderTitle(value) {
      if (value === null) {
        return 'Không xác định'
      }
      const maps = [
        'Nam',
        'Nữ',
        'Khác'
      ]

      return maps[value]
    },
    getCourseGenderStatistics() {
      courseGenderStatistic(this.course._id)
        .then(response => {
          const data = response.data
          this.$set(this, 'genderChart', {
            labels: data.map(item => this.getGenderTitle(item._id)),
            datasets: [
              {
                data: data.map(item => item.count),
                backgroundColor: ['#ffa600', '#f95d6a', '#2f4b7c', '#d45087', '#ff7c43']
              }
            ]
          })
        })
    },
    getCourseProgressStatistics() {
      courseProgressStatistic(this.course._id)
        .then(response => {
          const data = response.data
          this.$set(this, 'progressChart', {
            labels: data.map(item => item._id),
            datasets: [
              {
                label: 'Tài khoản',
                borderColor: '#e67f83',
                backgroundColor: '#f2bfc1',
                data: data.map(item => item.count)
              }
            ]
          })
        })
    },
    copyToClipboard (text, event) {
      const clipboard = new Clipboard(event.target, {
        text: () => text
      })

      clipboard.on('success', () => {
        this.$bvToast.toast('Copy to clipboard success', {
          variant: 'info'
        })
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$bvToast.toast('Copy to clipboard failed', {
          variant: 'error'
        })
        clipboard.destroy()
      })

      clipboard.onClick(event)
    },
    handleReview(index, homework) {
      this.homeworkTempIndex = index
      this.homeworkTemp = _.cloneDeep(homework)
      this.reviewHomeWorkDialog = true
    },

    getMediaUrl(url) {
      return this.$options.filters.getMediaUrl(url)
    },

    reviewHomework() {
      this.$store.dispatch('course/ReviewHomework', {
        index: this.homeworkTempIndex,
        homework: this.homeworkTemp
      }).then(data => {
        this.$bvToast.toast(data.success, {
          title: 'Thành công',
          variant: 'success'
        })
      }).catch(error => {
        this.$bvToast.toast(this.get(error, 'response.data.error.message') || error.message, {
          title: 'Thất bại',
          variant: 'danger'
        })
      })
    },

    get(obj, path) {
      return _.get(obj, path)
    },

    async initCourse() {
      if (!this.courses) {
        this.loading = true
        await this.$store.dispatch('course/GetCourses', {
          sort: '-created_at'
        })
        this.loading = false
      }

      if (this.course) {
        const index = this.courses.findIndex(item => item._id === this.course._id)
        this.course = index < 0 ? null : this.courses[index]
      } else {
        this.course = this.courses[0]
      }

      if (this.course) {
        this.$store.dispatch('course/GetStudents', {
          course_id: this.course._id
        })

        this.$store.dispatch('course/GetHomeworks', {
          course_id: this.course._id
        })

        this.initStatistics()
      } else {
        this.$store.dispatch('course/SetStudents', [])
        this.$store.dispatch('course/SetHomeworks', [])
      }
    },

    async loadCourse(val) {
      this.$store.dispatch('course/GetStudents', {
        course_id: this.course._id
      })

      this.$store.dispatch('course/GetHomeworks', {
        course_id: this.course._id
      })
    }
  }
}
</script>

<style lang="scss">
.course {
  .course-title {
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0.01em;

    color: #FFFFFF;
  }

  .course-overview {
    .border-right {
      border-right: 1px solid #D8D7D6;
    };
  }

  .rating-point {
    font-size: 24px;
    line-height: 120%;
    color: #FFFFFF;
    font-weight: 300;
  }

  .student-list {
    background-color: #F5F8FD;

    .card-title {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      color: #2F598A;
    }
    .num-student {
      font-family: 'Inter';
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      display: flex;
      align-items: center;
      color: #4F67E1;
    }
    .table-ranking .ranking-item:before {
      background-color: transparent;
    }
    .student-name {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      color: #2F598A;
    }
  }

  .topic-card-list {
    .category-card {
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      padding: 4px 8px 4px 8px;
      font-size: 13px;
      height: 28px;
      background: rgba(0, 0, 0, 0.12);
      backdrop-filter: blur(80px);
      border-radius: 14px;
      color: white;
    }
  }

  .course-statistic {
    .statistic {
      font-weight: 600;
      font-size: 16px;
      color: #000000;
    }

    .info {
      font-size: 14px;
      .title {
        color: #848B96;
      }
    }
  }

  .active-nav-item {
    color: #4F67E1 !important;
    font-weight: bold;
    border: none;
    border-bottom: 3px solid #4F67E1 !important;
  }

  .homeworks {
    font-size: 12px;

    .item-not-scored {
      background-color: #FFFFFF !important;
      border: 1px solid #EEF0F2;
      box-sizing: border-box;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
    }

    .item-scored {
      background-color: #F5F8FD !important;
      border-radius: 5px;
    }

    .homework-name {
      width: 150px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: '...';
    }
  }
}

.homework-review{
  background: #F5F8FD;
  border-radius: 12px;

  .content {
    font-size: 12px !important;
  }
}

.student-homework {
  background: #4477DB;
  border-radius: 12px;
  color: #FFFFFF;

  .content {
    font-size: 12px !important;
  }
}

.attachment {
  background: #E5E1DC;
  border-radius: 12px;
  // color: #FFFFFF;

  .attachment-file {
    font-size: 12px !important;
    // color: #FFFFFF;
  }
}

.homework-dialog {
  .btn-primary {
    background-color: #FF5A8D;
    border-color: #FF5A8D;
  }
}
</style>
